export enum ImportSource {
    Geofence = 0,
    RouteTemplate = 1
}
